import React, { useEffect } from "react"
import Button from "@material-ui/core/Button"
import Snackbar from "@material-ui/core/Snackbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import usePWA from "react-pwa-install-prompt"

export default function PwaChrome(props) {
  const { isStandalone, isInstallPromptSupported, promptInstall } = usePWA()

  const [open, setOpen] = React.useState(true)

  var showSnack =
    typeof window.localStorage !== "undefined" &&
    new Date(Number(window.localStorage.getItem("chrome-pwa-hide-until"))) <
      new Date() &&
    typeof window.chrome !== "undefined" &&
    typeof window.navigator !== "undefined" &&
    !!window.chrome &&
    !/Edge/.test(navigator.userAgent)

  useEffect(() => {
    console.log("showsnack", showSnack)

    if (showSnack) {
      typeof window?.gtag !== "undefined" &&
        window.gtag("event", "pwa_telemetry", {
          chrome_initial_shown: true,
        })
    }
  }, [showSnack])

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }

    setOpen(false)
    var date1 = new Date()
    date1.setDate(date1.getDate() + 1)

    typeof window.localStorage !== "undefined" &&
      window.localStorage.setItem("chrome-pwa-hide-until", date1.getTime())
  }

  useEffect(() => {
    if (isInstallPromptSupported && !isStandalone) {
      typeof window?.gtag !== "undefined" &&
        window.gtag("event", "pwa_telemetry", {
          chrome_changed_shown: true,
        })
      setOpen(true)
    }
  }, [isStandalone, isInstallPromptSupported])

  const onClickInstall = async () => {
    typeof window?.gtag !== "undefined" &&
      window.gtag("event", "pwa_telemetry", {
        chrome_clicked: true,
      })
    const didInstall = await promptInstall()
    if (didInstall) {
      typeof window?.gtag !== "undefined" &&
        window.gtag("event", "pwa_telemetry", {
          chrome_has_installed: true,
        })
    } else {
      typeof window?.gtag !== "undefined" &&
        window.gtag("event", "pwa_telemetry", {
          chrome_not_installed: false,
        })
    }
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={showSnack && open}
      onClose={handleClose}
      message="Die tankchecker.de App dem Homescreen hinzufügen?"
      action={
        <>
          <Button
            color="secondary"
            size="small"
            onClick={() => onClickInstall()}
          >
            Install
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  )
}
